import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { useImmer } from "use-immer";
import { Icon } from "@iconify/react";
import { getAllAccount } from "../Store/Actions/TicketAction";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import {
  Autocomplete,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import "./NewChat.css";
import Loader from "../Components/Loader";
import mapWATemplate from "../Helper/mapWATemplate";
import renderButtons from "../Helper/renderButtons";
import renderWAPreviewBody from "../Helper/renderWAPreviewBody";
import WhatsappBusinessSession from "../Images/WhatsappBusinessSession.svg";
import WhatsappSession from "../Images/WhatsappSession.svg";
import { setMakeCall } from "../Store/Actions/CallAction";

import {
  getContactList,
  readchat,
  // getSessionList
} from "../Store/Actions/ChatAction";

import {
  getWABAPermission,
  getWATemplateList,
  sendWAMessageTemplateText,
} from "../Store/Actions/WABAAction";

import { UPDATE_CHAT } from "../Store/Types/ChatTypes";

const NewChat = ({
  setOpenModal,
  sendMessage,
  parentMsgParam,
  isFollowUp,
  updateTicket,
  agentID,
  isSendingCallPermissionRequest,
  setIsSendingCallPermissionRequest,
  recipientPhoneNo,
  WABAAccountID,
  isFromContactInformation,
  contactID,
  campaignID,
  phoneTypeID,
  isTelemarketing,
  contactName,
  assignmentID,
  isFromNewChatButton,
  setIsFromNewChatButton,
  setIsContactDetailsModalShown,
  contactDetails,
}) => {
  const [disable, setDisable] = useState(true);
  const [ChannelList, setChannelList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //DIFFERENT LIST FOR SEARCHING CONTACTNAME AND NUMBER
  const [contactList, setContactList] = useState([]);
  const [numberList, setNumberList] = useState([]);

  //SelectionDiffrentChannel
  const [selectedChannel, setSelectedChannel] = useState(
    isSendingCallPermissionRequest ? WABAAccountID : ""
  );

  const [isSelected, setIsSelected] = useState(
    isSendingCallPermissionRequest ? "WABA" : ""
  );

  const [responseTemplateList, setResponseTemplateList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  // const [recipientName, setRecipientName] = useState("");

  const [currentStep, setCurrentStep] = useState(
    isFollowUp || isSendingCallPermissionRequest ? 2 : 1
  );

  const [msgParam, setMsgParam] = useState({
    ...parentMsgParam,
    number: isSendingCallPermissionRequest ? recipientPhoneNo : "",
    newchat: true,
    contactname: isFromContactInformation ? contactName : "",
  });

  const initialComponentsValues = {
    header: {
      mediaType: "none",
      mediaLink: null,

      attachment: {
        name: null,
        type: null,
        size: null,
        file: null,
      },

      headerText: null,
      headerVariable: null,
      headerVariableName: null,
    },

    bodyText: "Sample Body Text",
    bodyVariable1: null,
    bodyVariableName1: null,
    bodyVariable2: null,
    bodyVariableName2: null,
    bodyVariable3: null,
    bodyVariableName3: null,
    bodyVariable4: null,
    bodyVariableName4: null,
    bodyVariable5: null,
    bodyVariableName5: null,
    bodyVariable6: null,
    bodyVariableName6: null,
    bodyVariable7: null,
    bodyVariableName7: null,
    bodyVariable8: null,
    bodyVariableName8: null,
    bodyVariable9: null,
    bodyVariableName9: null,
    bodyVariable10: null,
    bodyVariableName10: null,
    footerText: "",
    button: [],
  };

  // useImmer used for easier state update
  const [componentsValues, updateComponentsValues] = useImmer(
    initialComponentsValues
  );

  const [isSending, setIsSending] = useState(false);
  const [existChatID, setExistChatID] = useState(0);
  const [isGettingPermission, setIsGettingPermission] = useState(true);
  const [permission, setPermission] = useState(null);
  const [selectedAction, setSelectedAction] = useState("");
  const dispatch = useDispatch();
  const { CurrentState } = useSelector((state) => state.auth);

  function SyncNameNumber(e, evalue, reason, type) {
    if (e === null) return;
    let val,
      target = "";
    //reset >> Select dropdown option from autocomplete
    //clear >> clear autocomplete field

    if (reason !== "reset" && reason !== "clear") {
      inputHandle(e);
    } else if (reason === "clear" || (evalue && evalue.length === 0)) {
      //SHOULD CLEAR BOTH OR JUST 1 FIELD
      // setMsgParam({ ...msgParam, [type]: "" });
      setMsgParam({ ...msgParam, [type]: "" });
    } else {
      switch (type) {
        case "contactname":
          target = "number";
          val = contactList.find((x) => x.Name === evalue).MobileNo;
          break;
        case "number":
          target = "contactname";
          val = numberList.find((x) => x.MobileNo === evalue).Name;
          break;
        default:
          break;
      }

      setMsgParam({ ...msgParam, [target]: val, [type]: evalue });
    }
  }

  function renderBodyVariableTextFields() {
    let textFields = [];

    if (componentsValues.parameterFormat === "named") {
      // Find all instances of named variables in the text
      const variables = [
        ...componentsValues.bodyText.matchAll(/\{\{([^}]+)\}\}/g),
      ];

      variables.forEach((match, index) => {
        const key = `bodyVariable${index + 1}`;

        textFields.push(
          match[1].includes("date") || match[1].includes("tanggal") ? (
            <DatePicker
              format="DD/MM/YYYY"
              label={match[1]}
              value={
                componentsValues[key]
                  ? moment(componentsValues[key], "DD-MM-yyyy")
                  : null
              }
              renderInput={(params) => <TextField {...params} />}
              onChange={(e) =>
                updateComponentsValues((draft) => {
                  draft[key] = e ? moment(e).format("DD-MM-yyyy") : null;
                  draft[`bodyVariableName${index + 1}`] = match[1];
                })
              }
            />
          ) : (
            <TextField
              key={index + 1}
              label={match[1]}
              required
              value={componentsValues[key]}
              onChange={(e) =>
                updateComponentsValues((draft) => {
                  draft[key] = e.target.value;
                  draft[`bodyVariableName${index + 1}`] = match[1];
                })
              }
            />
          )
        );
      });
    } else {
      // Find all instances of "{{n}}" in the text
      const variables = [
        ...componentsValues.bodyText.matchAll(/\{\{(\d+)\}\}/g),
      ].map((match) => Number(match[1]));

      variables.forEach((num) => {
        const key = `bodyVariable${num}`;

        textFields.push(
          <TextField
            key={num}
            label={`Variable ${num}`}
            required
            value={componentsValues[key]}
            onChange={(e) =>
              updateComponentsValues((draft) => {
                draft[key] = e.target.value;
              })
            }
          />
        );
      });
    }

    return textFields;
  }

  function renderHeaderVariableTextField() {
    let headerVariableName = extractHeaderVariableName() ?? "";

    if (
      headerVariableName.includes("date") ||
      headerVariableName.includes("tanggal")
    ) {
      return (
        <DatePicker
          format="DD/MM/YYYY"
          label={headerVariableName}
          value={
            componentsValues.header.headerVariable
              ? moment(componentsValues.header.headerVariable, "DD-MM-yyyy")
              : null
          }
          renderInput={(params) => <TextField {...params} />}
          onChange={(e) =>
            updateComponentsValues((draft) => {
              draft.header.headerVariable = e
                ? moment(e).format("DD-MM-yyyy")
                : null;
            })
          }
        />
      );
    } else {
      return (
        <TextField
          label={
            componentsValues.parameterFormat === "named"
              ? extractHeaderVariableName()
              : "Header variable"
          }
          required
          value={componentsValues.header.headerVariable}
          onChange={(e) => {
            updateComponentsValues((draft) => {
              draft.header.headerVariable = e.target.value;
            });
          }}
        />
      );
    }
  }

  useEffect(() => {
    if (
      msgParam.session !== "" &&
      msgParam.contactname?.trim() !== "" &&
      msgParam.number?.length > 8 &&
      msgParam.message?.trim() !== ""
    )
      setDisable(false);
    else setDisable(true);
  }, [msgParam]);

  useEffect(() => {
    setIsLoading(true);

    // Get agent data for search select options
    getAllAccount(agentID)
      .then((response) => {
        if (response.status) {
          setChannelList(response.data);
          setIsLoading(false);
        } else {
          toast.error("Error fetching accounts", {
            autoClose: 3000,
          });

          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        toast.error("Error fetching accounts", {
          autoClose: 3000,
        });

        console.log("err", err);
        setIsLoading(false);
      });
  }, []);

  useEffect(() => {
    function getContactsNewChat(type) {
      setContactList([]);
      setNumberList([]);

      if (
        (type === "contactname" &&
          msgParam.contactname !== undefined &&
          msgParam.contactname.length < 3) ||
        (type === "number" &&
          msgParam.number !== undefined &&
          msgParam.number.length < 5)
      ) {
        return;
      }

      let param =
        type === "contactname"
          ? msgParam.contactname
          : type === "number"
          ? msgParam.number
          : "";

      getContactList(msgParam.session, type, param)
        .then((response) => {
          if (response.status) {
            let contactArray = [];

            if (response.data && response.data.length > 0) {
              response.data.forEach((c) => {
                let contact = {
                  ContactID: c.ContactID,
                  Name: c.Name,

                  //MobileNo skip the if start with "62"
                  MobileNo: c.MobileNo.startsWith("62")
                    ? c.MobileNo.substring(2)
                    : c.MobileNo,
                };

                contactArray.push(contact);
              });

              if (type === "contactname") setContactList(contactArray);
              if (type === "number") setNumberList(contactArray);
            }
          }
        })
        .catch((err) => {
          setContactList([]);
          setNumberList([]);
          toast.warn(err.error);
        });
    }
    //SEARCH IF CONTACT/NUMBER EXISTS DATABASE
    if (msgParam.contactname) {
      getContactsNewChat("contactname");
    }

    if (msgParam.number) {
      getContactsNewChat("number");
    }
  }, [msgParam.contactname, msgParam.number]);

  useEffect(() => {
    if (isSendingCallPermissionRequest) {
      getWATemplateList(WABAAccountID)
        .then((response) => {
          if (response.status) {
            process.env.NODE_ENV === "development" &&
              console.log("Response template list: ", response.data);

            setResponseTemplateList(response.data);
          } else {
            console.log("error", response.error);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, []);

  useEffect(() => {
    if (
      currentStep === 2 &&
      isFromContactInformation &&
      isSelected === "WABA"
    ) {
      let formattedPhoneNo;

      if (recipientPhoneNo.charAt(0) === "0") {
        formattedPhoneNo = "62" + recipientPhoneNo.slice(1);
      } else {
        formattedPhoneNo = recipientPhoneNo;
      }

      getWABAPermission(formattedPhoneNo, selectedChannel)
        .then((response) => {
          if (response.status) {
            setPermission(response.data);
            setIsGettingPermission(false);
          } else {
            console.log("error", response.error);

            toast.error("Error getting call permission", {
              autoClose: 3000,
            });

            setIsGettingPermission(false);
          }
        })
        .catch((err) => {
          console.log("err", err);

          toast.error("Error getting call permission", {
            autoClose: 3000,
          });

          setIsGettingPermission(false);
        });
    }

    // Auto input variables based on data from contact details
    if (
      (currentStep === 3 &&
        isFromContactInformation &&
        isSelected === "WABA") ||
      currentStep === 4
    ) {
      if (componentsValues.parameterFormat === "named" && contactDetails) {
        const variables = [
          ...componentsValues.bodyText.matchAll(/\{\{([^}]+)\}\}/g),
        ];

        // Convert contactDetails keys to lowercase
        const convertedContactDetails = Object.fromEntries(
          Object.entries(contactDetails).map(([key, value]) => [
            key.toLowerCase(),
            value,
          ])
        );

        variables.forEach((variable, index) => {
          if (Object.hasOwn(convertedContactDetails, variable[1])) {
            updateComponentsValues((draft) => {
              draft[`bodyVariable${index + 1}`] =
                convertedContactDetails[variable[1]];

              draft[`bodyVariableName${index + 1}`] = variable[1];
            });
          }
        });
      }
    }
  }, [currentStep]);

  const inputHandle = (e) => {
    if (e.target.id === "number") {
      let pattern = /^\d*$/;
      //STOP IF NOT NUMBER
      if (!pattern.test(e.target.value)) {
        return;
      }
    }
    setMsgParam({
      ...msgParam,
      [e.target.id]: e.target.value,
    });
  };

  const sendNewChat = () => {
    readchat(existChatID, msgParam.session, "62" + msgParam.number);

    // Format phone number. If it begins with "0" replace it with "62". If it begins with "8" append with "62"
    let formattedNumber = isFromNewChatButton
      ? msgParam.number
      : recipientPhoneNo;

    if (formattedNumber.charAt(0) === "0") {
      formattedNumber = "62" + formattedNumber.slice(1);
    } else if (formattedNumber.charAt(0) === "8") {
      formattedNumber = "62" + formattedNumber;
    }

    sendMessage({
      ...msgParam,
      number: formattedNumber,
      type: "chat",
    });

    handleClose();
  };

  const validateNextButton = () => {
    if (currentStep === 1) {
      if (isSelected) {
        return false;
      } else if (isSelected === "") {
        return true;
      }
    }

    if (currentStep === 2 && isSelected === "WABA") {
      if (isFromContactInformation) {
        if (!selectedAction) {
          return true;
        }
      } else {
        if (!selectedTemplate.ID || !msgParam.number) {
          return true;
        }
      }
    }

    if ((currentStep === 3 || currentStep === 4) && isSelected === "WABA") {
      if (currentStep === 3 && isFromContactInformation) {
        if (!selectedTemplate.ID) {
          return true;
        }
      } else {
        // Checks for any empty variable
        if (componentsValues.parameterFormat === "named") {
          const hasEmptyHeaderVariable =
            /\{\{[^}]+\}\}/.test(componentsValues.header.headerText ?? "") &&
            !componentsValues.header.headerVariable;

          // Find all {{...}} patterns in bodyText
          const matches =
            componentsValues.bodyText.match(/\{\{[^}]+\}\}/g) || [];

          // Check if any matched variable has an empty value
          const hasEmptyBodyVariable = matches.some((placeholder, index) => {
            const variableValue = componentsValues[`bodyVariable${index + 1}`];
            return !variableValue; // placeholder exists but value is empty
          });

          if (hasEmptyHeaderVariable || hasEmptyBodyVariable) {
            return true;
          }
        } else {
          if (
            (componentsValues.header.headerText?.includes("{{1}}") &&
              !componentsValues.header.headerVariable) ||
            (componentsValues.bodyText?.includes("{{1}}") &&
              !componentsValues.bodyVariable1) ||
            (componentsValues.bodyText?.includes("{{2}}") &&
              !componentsValues.bodyVariable2) ||
            (componentsValues.bodyText?.includes("{{3}}") &&
              !componentsValues.bodyVariable3) ||
            (componentsValues.bodyText?.includes("{{4}}") &&
              !componentsValues.bodyVariable4) ||
            (componentsValues.bodyText?.includes("{{5}}") &&
              !componentsValues.bodyVariable5) ||
            (componentsValues.bodyText?.includes("{{6}}") &&
              !componentsValues.bodyVariable6) ||
            (componentsValues.bodyText?.includes("{{7}}") &&
              !componentsValues.bodyVariable7) ||
            (componentsValues.bodyText?.includes("{{8}}") &&
              !componentsValues.bodyVariable8) ||
            (componentsValues.bodyText?.includes("{{9}}") &&
              !componentsValues.bodyVariable9) ||
            (componentsValues.bodyText?.includes("{{10}}") &&
              !componentsValues.bodyVariable10)
          ) {
            return true;
          }
        }
      }

      if (isSending) {
        return true;
      }
    }

    return false;
  };

  const renderNextButtonText = () => {
    if (isSelected) {
      if (
        (currentStep === 3 && !isFromContactInformation) ||
        currentStep === 4
      ) {
        if (isSending) {
          return (
            <>
              <Icon height="22" icon="eos-icons:loading" />
              Sending...
            </>
          );
        }

        return "Send";
      }
    }

    if (isSelected === "WA") {
      if (currentStep === 2) {
        return "Send";
      }
    }

    if (
      selectedAction === "call" &&
      permission?.actions[1]?.boleh_dilakukan === "Ya"
    ) {
      return "Call";
    }

    return "Next";
  };

  const handleClose = () => {
    setExistChatID(0);
    setOpenModal(false);
    setIsFromNewChatButton && setIsFromNewChatButton(false);
    dispatch({ type: UPDATE_CHAT });
    setIsSendingCallPermissionRequest(false);
    setSelectedAction("");
  };

  const confirmNewChat = (e) => {
    e.preventDefault();
    setIsSending(true);
    setDisable(true);

    setTimeout(() => {
      setDisable(false);
    }, 2000);

    // Format phone number. If it begins with "0" replace it with "62". If it begins with "8" append with "62"
    let formattedPhoneNo = isFromNewChatButton
      ? msgParam.number
      : recipientPhoneNo;

    if (formattedPhoneNo.charAt(0) === "0") {
      formattedPhoneNo = "62" + formattedPhoneNo.slice(1);
    } else if (formattedPhoneNo.charAt(0) === "8") {
      formattedPhoneNo = "62" + formattedPhoneNo;
    }

    let bodyParametersArray = [];

    let componentsArray = [
      {
        type: "header",
        parameters: [],
      },

      {
        type: "body",
        parameters: bodyParametersArray,
      },
    ];

    if (componentsValues.header.headerVariable) {
      componentsArray[0].parameters[0] = {
        type: "text",
        parameter_name: componentsValues.header.headerVariableName,
        text: componentsValues.header.headerVariable,
      };
    }

    if (componentsValues.header.mediaType === "image" && componentsValues.header.mediaLink) {
      componentsArray[0].parameters.push({
        type: "image",
        image: { link: componentsValues.header.mediaLink }
      });
    }

    if (componentsValues.bodyVariable1) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName1,
        text: componentsValues.bodyVariable1,
      });
    }

    if (componentsValues.bodyVariable2) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName2,
        text: componentsValues.bodyVariable2,
      });
    }

    if (componentsValues.bodyVariable3) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName3,
        text: componentsValues.bodyVariable3,
      });
    }

    if (componentsValues.bodyVariable4) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName4,
        text: componentsValues.bodyVariable4,
      });
    }

    if (componentsValues.bodyVariable5) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName5,
        text: componentsValues.bodyVariable5,
      });
    }

    if (componentsValues.bodyVariable6) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName6,
        text: componentsValues.bodyVariable6,
      });
    }

    if (componentsValues.bodyVariable7) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName7,
        text: componentsValues.bodyVariable7,
      });
    }

    if (componentsValues.bodyVariable8) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName8,
        text: componentsValues.bodyVariable8,
      });
    }

    if (componentsValues.bodyVariable9) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName9,
        text: componentsValues.bodyVariable9,
      });
    }

    if (componentsValues.bodyVariable10) {
      bodyParametersArray.push({
        type: "text",
        parameter_name: componentsValues.bodyVariableName10,
        text: componentsValues.bodyVariable10,
      });
    }

    sendWAMessageTemplateText({
      recipientphoneno: formattedPhoneNo,

      template: {
        name: selectedTemplate.TemplateName,
        language: { code: selectedTemplate.Language },
        components: componentsArray,
      },

      wabaaccountid: selectedChannel,
      outboundcontactid: contactID,
      assignmentid: assignmentID,
      campaignid: campaignID,
      templateid: selectedTemplate.ID,
    })
      .then((response) => {
        if (response.status) {
          if (isFollowUp) {
            updateTicket();

            toast.success("Follow Up Message sent", {
              autoClose: 3000,
            });
          } else {
            toast.success("Message sent", {
              autoClose: 3000,
            });
          }

          setIsSending(false);
          handleClose();
        } else {
          console.log("error", response.error);
          toast.error(response.error, { autoClose: 3000 });
          setIsSending(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(err, { autoClose: 3000 });
        setIsSending(false);
      });
  };

  const handleSelection = (id, type) => {
    setSelectedChannel(id);
    setIsSelected(type);

    setMsgParam({
      ...msgParam,
      session: "dev1",
    })

    getWATemplateList(id)
      .then((response) => {
        if (response.status) {
          process.env.NODE_ENV === "development" &&
            console.log("Response template list: ", response.data);

          setResponseTemplateList(response.data);
          // setIsResponseTemplateListLoading(false);
        } else {
          console.log("error", response.error);
          // setIsResponseTemplateListLoading(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        // setIsResponseTemplateListLoading(false);
      });
  };

  const NewChatFormInput = (
    <div className="newChatformInput">
      <form
        onSubmit={confirmNewChat}
        component="form"
        sx={{
          "& > :not(style)": { m: 1, width: "25ch" },
          borderRadius: "20px",
        }}
        autoComplete="off"
      >
        <ul>
          <div>
            {(isSelected === "WABA" || isSendingCallPermissionRequest) && (
              <>
                <li className="ContainerT1">
                  <TextField
                    required
                    sx={{
                      width: "100%",
                    }}
                    label="Select Template"
                    select
                    value={selectedTemplate.ID}
                  >
                    {responseTemplateList.length ? (
                      responseTemplateList
                        ?.filter((responseTemplate) =>
                          isSendingCallPermissionRequest
                            ? responseTemplate.IsCallPermission
                            : responseTemplate
                        )
                        ?.map((responseTemplate) => (
                          <MenuItem
                            disabled={responseTemplate.Status !== "APPROVED"}
                            key={responseTemplate.ID}
                            value={responseTemplate.ID}
                            onClick={() => {
                              updateComponentsValues(initialComponentsValues);
                              setSelectedTemplate(responseTemplate);

                              updateComponentsValues((draft) =>
                                mapWATemplate(draft, responseTemplate)
                              );
                            }}
                          >
                            {responseTemplate.TemplateName}
                          </MenuItem>
                        ))
                    ) : (
                      <MenuItem disabled>No template found.</MenuItem>
                    )}
                  </TextField>
                </li>

                <li className="ContainerT1">
                  <Autocomplete
                    disabled={isSendingCallPermissionRequest}
                    freeSolo
                    id="number"
                    value={
                      isFromNewChatButton ? msgParam.number : recipientPhoneNo
                    }
                    inputValue={
                      isFromNewChatButton ? msgParam.number : recipientPhoneNo
                    }
                    options={numberList.map((c) => c.MobileNo)}
                    getOptionLabel={(option) => option.MobileNo || option}
                    onInputChange={(e, value, reason) => {
                      SyncNameNumber(e, value, reason, "number");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        size="small"
                        sx={{ borderRadius: "16px", width: "100%" }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <span>+62</span>
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        label="Contact Number"
                        placeholder="Contact Number"
                        value={
                          isFromNewChatButton
                            ? msgParam.number
                            : recipientPhoneNo
                        }
                      />
                    )}
                  />
                </li>
              </>
            )}

            {isSelected === "WA" && (
              <>
                {/* {sessions && sessions.length > 1 ? ( */}

                {!isFromContactInformation && (
                  <div className="select-container">
                    <li className="ContainerT1">
                      <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">
                          Session
                        </InputLabel>

                        <Select
                          required
                          id="session"
                          label="Session"
                          value={msgParam.session}
                          onChange={(e) =>
                            setMsgParam({
                              ...msgParam,
                              session: e.target.value,
                            })
                          }
                        >
                          {/* {sessions &&
                                      sessions.length > 1 &&
                                      sessions.map((s) => ( */}
                          <MenuItem value="dev1">dev1</MenuItem>
                          {/* ))} */}
                        </Select>
                      </FormControl>
                    </li>
                  </div>
                )}

                {/* ) : (
                            <div hidden>
                              <li className="ContainerT1">
                                <TextField required id="session" value={msgParam.session} />
                              </li>
                            </div>
                          )} */}

                <li className="ContainerT1">
                  <Autocomplete
                    disabled={isSendingCallPermissionRequest}
                    freeSolo
                    id="contactname"
                    value={contactName ?? msgParam.contactname}
                    inputValue={contactName ?? msgParam.contactname}
                    options={contactList.map((c) => c.Name)}
                    getOptionLabel={(option) => option.Name || option}
                    onInputChange={(e, value, reason) => {
                      SyncNameNumber(e, value, reason, "contactname");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        size="small"
                        sx={{ borderRadius: "16px", width: "100%" }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon
                                className="icon"
                                height="24"
                                icon="fluent:contact-card-24-regular"
                              />
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        label="Customer Name"
                        placeholder="Customer Name"
                        value={contactName ?? msgParam.contactname}
                      />
                    )}
                  />
                </li>

                <li className="ContainerT1">
                  <Autocomplete
                    disabled={isSendingCallPermissionRequest}
                    freeSolo
                    id="number"
                    value={
                      isFromNewChatButton ? msgParam.number : recipientPhoneNo
                    }
                    inputValue={
                      isFromNewChatButton ? msgParam.number : recipientPhoneNo
                    }
                    options={numberList.map((c) => c.MobileNo)}
                    getOptionLabel={(option) => option.MobileNo || option}
                    onInputChange={(e, value, reason) => {
                      SyncNameNumber(e, value, reason, "number");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        size="small"
                        sx={{ borderRadius: "16px", width: "100%" }}
                        InputProps={{
                          ...params.InputProps,
                          startAdornment: (
                            <InputAdornment position="start">
                              <span>+62</span>
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        label="Contact Number"
                        placeholder="Contact Number"
                        value={
                          isFromNewChatButton
                            ? msgParam.number
                            : recipientPhoneNo
                        }
                      />
                    )}
                  />
                </li>

                <li className="ContainerT1">
                  <TextField
                    required
                    sx={{
                      width: "100%",
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                    id="message"
                    label="Your Message"
                    multiline
                    value={msgParam.message}
                    onChange={(e) =>
                      setMsgParam({
                        ...msgParam,
                        message: e.target.value,
                      })
                    }
                  />
                </li>
              </>
            )}
          </div>
        </ul>
      </form>
    </div>
  );

  const CallPermission = isGettingPermission ? (
    <Loader />
  ) : permission !== null ? (
    <div className="call-permission">
      <p className="permission-status">
        Call permission status: {permission.call_permission.status}
      </p>

      <div className="action-list">
        <div
          className={`action selection call ${
            selectedAction === "call" ? "selected" : ""
          } ${
            permission.actions[0]?.boleh_dilakukan !== "Ya" &&
            permission.actions[1]?.boleh_dilakukan !== "Ya"
              ? "disabled"
              : ""
          }`}
          onClick={() => {
            if (
              permission.actions[0]?.boleh_dilakukan === "Ya" ||
              permission.actions[1]?.boleh_dilakukan === "Ya"
            ) {
              setSelectedAction("call");
            }
          }}
        >
          <div className="name-selected">
            <p className="action-name">Call Customer</p>
          </div>

          <Icon height="80" icon="material-symbols:call" />

          <div>
            <div className="limit">
              <p className="selected-amount">
                {permission.actions[0]?.boleh_dilakukan === "Ya" ||
                permission.actions[1]?.boleh_dilakukan === "Ya"
                  ? "Call customer using WhatsApp. Limitations apply"
                  : "You have exceeded all call request allowances. Please try again later."}
              </p>
            </div>
          </div>
        </div>

        <div
          className={`action selection request ${
            selectedAction === "message" ? "selected" : ""
          }`}
          onClick={() => setSelectedAction("message")}
        >
          <div className="name-selected">
            <p className="action-name">Send Message</p>
          </div>

          <Icon height="80" icon="mdi:message" />

          <div>
            <div className="limit">
              <p className="selected-amount">Send a new message template</p>
            </div>
          </div>
        </div>
      </div>

      <div className="call-request-allowance">
        <h3>Call request allowance</h3>

        {permission.actions[1] && (
          <div>
            <h4>Calls</h4>
            <p>{permission.actions[1]?.limit[0].periode}</p>
          </div>
        )}

        <div>
          <h4>Call Permission Request</h4>
          <p>{permission.actions[0].limit[0].periode}</p>
          <p>{permission.actions[0].limit[1].periode}</p>
        </div>
      </div>
    </div>
  ) : (
    <p className="call-permission-error">
      Error getting call permission. Please try again later.
    </p>
  );

  const PreviewStep = (
    <div
      className={`preview-step ${
        /\{\{[^}]+\}\}/.test(componentsValues.header.headerText ?? "") ||
        /\{\{[^}]+\}\}/.test(componentsValues.bodyText)
          ? "has-variables"
          : ""
      }`}
    >
      {(/\{\{[^}]+\}\}/.test(componentsValues.header.headerText ?? "") ||
        /\{\{[^}]+\}\}/.test(componentsValues.bodyText)) && (
        <section className="form">
          <p className="title">Set Variables</p>

          {/\{\{[^}]+\}\}/.test(componentsValues.header.headerText ?? "") &&
            renderHeaderVariableTextField()}

          {renderBodyVariableTextFields()}
        </section>
      )}

      <section
        className={`preview-screen-container ${
          /\{\{[^}]+\}\}/.test(componentsValues.header.headerText ?? "") ||
          /\{\{[^}]+\}\}/.test(componentsValues.bodyText)
            ? "has-variables"
            : ""
        }`}
      >
        <p className="title">Preview</p>

        <div className="preview-screen">
          <div
            className={`preview-message ${
              componentsValues.button.length ? "has-buttons" : ""
            }`}
          >
            {componentsValues.header.headerText && (
              <header>{renderWAPreviewHeader()}</header>
            )}

            <p
              className="body-text"
              dangerouslySetInnerHTML={{
                __html: renderWAPreviewBody(
                  componentsValues,
                  componentsValues.bodyText,
                  false,
                  componentsValues.parameterFormat
                ),
              }}
            />

            {componentsValues.footerText && (
              <footer>{componentsValues.footerText}</footer>
            )}

            <p className="time">{moment().format("HH:mm")}</p>

            <div className="button-container">
              {renderButtons(componentsValues.button)}
            </div>
          </div>

          {componentsValues.isCallPermission && (
            <div className="preview-message call-permission">
              <div className="text-container">
                <div>
                  <div className="call-icon">
                    <Icon height="24" icon="material-symbols:call" />
                  </div>

                  <p className="body-text">Can [Business Name] call you?</p>
                </div>

                <p className="time">{moment().format("HH:mm")}</p>
              </div>

              <div className="preference">
                <p>Choose preference</p>
                <Icon height="18" icon="mingcute:down-fill" />
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );

  function renderWAPreviewHeader() {
    if (componentsValues.parameterFormat === "named") {
      return componentsValues.header.headerText?.replace(
        /\{\{[^}]+\}\}/g,
        componentsValues.header.headerVariable
          ? componentsValues.header.headerVariable
          : `{{${componentsValues.header.headerVariableName}}}`
      );
    } else {
      return componentsValues.header.headerText?.replace(
        "{{1}}",
        componentsValues.header.headerVariable
          ? componentsValues.header.headerVariable
          : "{{1}}"
      );
    }
  }

  function extractHeaderVariableName() {
    const matchedPattern =
      componentsValues.header.headerText.match(/\{\{([^}]+)\}\}/);

    if (matchedPattern) {
      return matchedPattern[1];
    }
  }

  return (
    <div className="new-chat">
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <header>
          <h1>
            {isFollowUp
              ? "Initiate Follow Up"
              : isFromContactInformation
              ? "WhatsApp"
              : "New Message"}
          </h1>

          <CloseOutlinedIcon className="close-button" onClick={handleClose} />
        </header>

        <div className="session-select">
          {currentStep !== 3 && (
            <p className="title">
              {currentStep === 1
                ? "Select Session"
                : currentStep === 2 && isFromContactInformation
                ? "Select Action"
                : "Select Detail"}
            </p>
          )}

          {currentStep === 1 && (
            <div className="session-options">
              {isLoading ? (
                <Loader />
              ) : (
                <div>
                  {ChannelList.waba?.map((item, index) => (
                    <div
                      className={`session-option ${
                        selectedChannel === item.ID ? "selected" : ""
                      }`}
                      onClick={() => handleSelection(item.ID, "WABA")}
                      key={index}
                    >
                      <div
                        className={`option-logo ${
                          selectedChannel === item.ID ? "selected" : ""
                        }`}
                      >
                        <img
                          src={WhatsappBusinessSession}
                          alt=""
                          style={{ width: "42px", height: "42px" }}
                        />
                      </div>

                      <div className="option-detail">
                        <p className="option-text">{item.Name}</p>
                        <p className="option-text">{item.DisplayPhoneNo}</p>
                      </div>
                    </div>
                  ))}

                  <br />

                  {ChannelList.wa?.map((item, index) => (
                    <div
                      className={`session-option ${
                        selectedChannel === item.ID ? "selected" : ""
                      }`}
                      onClick={() => handleSelection(item.ID, "WA")}
                      key={index}
                    >
                      <div
                        className={`option-logo ${
                          selectedChannel === item.ID ? "selected" : ""
                        }`}
                      >
                        <img
                          src={WhatsappSession}
                          alt=""
                          style={{ width: "42px", height: "42px" }}
                        />
                      </div>

                      <div className="option-detail">
                        <p className="option-text">{item.WhatsappName}</p>
                      </div>
                    </div>
                  ))}
                </div>

                /* <div className="session-option">
                <div
                  className={`session-button ${
                    isSelected === "whatsapp" ? "selected" : ""
                  }`}
                  onClick={() => setisSelected("whatsapp")}
                >
                  <img src={WhatsappSession} alt="" />

                  {isSelected === "whatsapp" && (
                    <Icon
                      className="selected-icon"
                      color="#3F80FF"
                      icon="material-symbols:check-circle"
                      height="40"
                    />
                  )}
                </div>

                <p className="session-name">Whatsapp</p>
              </div> */

                /* <div className="session-option">
                <div
                  className={`session-button ${
                    isSelected === "WABA" ? "selected" : ""
                  }`}
                  onClick={() => setisSelected("WABA")}
                >
                  <img src={WhatsappBusinessSession} alt="" />

                  {isSelected === "WABA" && (
                    <Icon
                      className="selected-icon"
                      color="#3F80FF"
                      icon="material-symbols:check-circle"
                      height="40"
                    />
                  )}
                </div>

                <p className="session-name">Whatsapp Business</p>
              </div> */
              )}
            </div>
          )}

          {currentStep === 2 &&
            (isFromContactInformation && isSelected === "WABA"
              ? CallPermission
              : NewChatFormInput)}

          {currentStep === 3 &&
            (isFromContactInformation && isSelected === "WABA"
              ? NewChatFormInput
              : PreviewStep)}

          {currentStep === 4 && PreviewStep}
        </div>

        <footer>
          <div className="buttons">
            {currentStep !== 1 && (
              <button
                className="back"
                onClick={() => {
                  if (currentStep === 2) {
                    if (isFollowUp) {
                      handleClose();
                    }

                    setSelectedAction("");
                    setCurrentStep(currentStep - 1);
                  } else {
                    setCurrentStep(currentStep - 1);
                  }
                }}
              >
                Back
              </button>
            )}

            <button
              className="next"
              disabled={validateNextButton()}
              onClick={(e) => {
                if (isSelected === "WA") {
                  if (currentStep !== 2) {
                    setCurrentStep(currentStep + 1);
                  } else {
                    sendNewChat();
                  }
                } else {
                  if (currentStep !== 3 && currentStep !== 4) {
                    if (selectedAction === "call") {
                      if (permission?.actions[1]?.boleh_dilakukan === "Ya") {
                        setOpenModal(false);
                        setIsFromNewChatButton && setIsFromNewChatButton(false);
                        setIsContactDetailsModalShown && setIsContactDetailsModalShown(false);

                        dispatch(
                          setMakeCall({
                            agentStatus: CurrentState,
                            campaignID: campaignID,
                            contactID: contactID,
                            goToACW: true,
                            isTelemarketing: isTelemarketing ?? false,
                            isWACall: true,

                            phoneNo: `999${
                              recipientPhoneNo.charAt(0) === "0"
                                ? "62" + recipientPhoneNo.slice(1)
                                : recipientPhoneNo
                            }`,

                            phoneTypeID: phoneTypeID,
                          })
                        );
                      } else {
                        setIsSendingCallPermissionRequest(true);
                        setCurrentStep(currentStep + 1);
                      }
                    } else {
                      setCurrentStep(currentStep + 1);
                    }
                  } else {
                    if (currentStep === 3 && isFromContactInformation) {
                      setCurrentStep(currentStep + 1);
                    } else {
                      confirmNewChat(e);
                    }
                  }
                }
              }}
            >
              {renderNextButtonText()}
            </button>
          </div>

          {/* <div className="steps-indicator">
            {!isFollowUp && !isSendingCallPermissionRequest && (
              <div
                className={`indicator ${currentStep === 1 ? "active" : ""}`}
              />
            )}

            <div className={`indicator ${currentStep === 2 ? "active" : ""}`} />

            {isSelected === "WABA" && (
              <div
                className={`indicator ${currentStep === 3 ? "active" : ""}`}
              />
            )}

            {isSelected === "WABA" &&
              permission?.actions[1]?.boleh_dilakukan !== "Ya" && (
                <div
                  className={`indicator ${currentStep === 4 ? "active" : ""}`}
                />
              )}
          </div> */}
        </footer>

        {/* <div className="newChatformFooter">
          <div className="newChatbtnContainer">
            <button className="newChatbtn_Cancel" onClick={onClose}>
              Cancel
            </button>

            <button className="newChatbtn_Confirm" onClick={confirmNewChat}>
              Send
            </button>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default NewChat;
